(() => {
  const grid = document.getElementById('main-collection-product-grid');
  if (!grid) return;

  window.ProductSample = window.ProductSample || {};
  window.ProductSample.loadSamplesButton = true;

  let scheduled = false;
  let activeForm = null;
  const requestInitialization = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      if (grid.querySelector('[data-flooring-sample-form].js-product-sample-form') && window.ProductSamplesApp) {
        window.ProductSamplesApp.reInitButton();
      }
    });
  };

  const getForm = event => event.detail?.button?.closest('[data-flooring-sample-form]');

  document.body.addEventListener('afterRenderButton.productSamples', event => {
    const form = getForm(event);
    if (!form || !grid.contains(form)) return;
    const appMount = form.querySelector('[data-flooring-sample-app]');
    const appButton = appMount.querySelector('[product-samples-button]');
    const button = form.querySelector('.flooring-collection-card__sample');
    if (!appButton) return;
    form.classList.remove('js-product-sample-form');
    form.hidden = appMount.classList.contains('sample-hidden');
    button.disabled = !!activeForm || form.hidden || appMount.classList.contains('sample-disabled');
    if (form.dataset.sampleBound) return;
    form.dataset.sampleBound = 'true';
    button.addEventListener('click', () => {
      if (!button.disabled && !form.hidden) {
        form.querySelector('[role="status"]').textContent = '';
        appButton.click();
      }
    });
  });

  document.body.addEventListener('beforeAddToSample.productSamples', event => {
    const form = getForm(event);
    if (!form) return;
    activeForm = form;
    grid.querySelectorAll('.flooring-collection-card__sample').forEach(button => {
      button.disabled = true;
    });
    form.querySelector('.flooring-collection-card__sample').setAttribute('aria-busy', 'true');
  });

  const releaseButton = event => {
    const form = getForm(event);
    if (!form || (activeForm && activeForm !== form)) return;
    activeForm = null;
    grid.querySelectorAll('[data-flooring-sample-form][data-sample-bound]').forEach(item => {
      const mount = item.querySelector('[data-flooring-sample-app]');
      const button = item.querySelector('.flooring-collection-card__sample');
      button.disabled = item.hidden || mount.classList.contains('sample-disabled');
      button.removeAttribute('aria-busy');
    });
  };
  document.body.addEventListener('afterAddToSample.productSamples', releaseButton);
  document.body.addEventListener('addToCartError.productSamples', event => {
    releaseButton({ detail: { button: event.detail?.buttonEl } });
  });
  document.body.addEventListener('showNotification.productSamples', event => {
    const form = event.detail?.formEl;
    if (!form?.matches('[data-flooring-sample-form]')) return;
    form.querySelector('[role="status"]').textContent = event.detail.message || '';
    event.detail.notificationEl?.remove();
    releaseButton({ detail: { button: event.detail.buttonEl } });
  });

  document.body.addEventListener('ready.productSamples', requestInitialization);
  new MutationObserver(requestInitialization).observe(grid, { childList: true, subtree: true });
  requestInitialization();
})();